// Firebase Configuration
// Location: src/common/utils/firebase/firebase-config.js

export const firebaseConfig = {
  apiKey: "AIzaSyA5z8jiDCJvgaRbKx9v9PwSArl6jEj71EY",
  authDomain: "doctolinkapp-bbaa3.firebaseapp.com",
  projectId: "doctolinkapp-bbaa3",
  storageBucket: "doctolinkapp-bbaa3.appspot.com",
  messagingSenderId: "154700497240",
  appId: "1:154700497240:web:6801cce73305b996d4a52d",
  measurementId: "G-JL9E2YBB2W"
};

// VAPID Key for Web Push Notifications
export const FCM_VAPID_KEY = "BOVLoQUQPKM6RTQCJieCvmi-6rJGZaVBu4eIv91hEaYL5kHDG6s2E9IAiHjhwn7sbsk7bIxLL77kVgNuIBGqxhA";

